import React from 'react';
import {
  ApplicationIcon,
  Box,
  Chip,
  TabContent,
  Tooltip,
  Typography,
} from '@saviynt/design-system';

import { SodFieldSet } from '../../../../shared/components';
import { ENTITLEMENT_DEATILS_TABS } from '../../../../shared/constants';
import { useInvertedLocalize } from '../../../../shared/hooks';

import './EntitlementSummary.css';

interface EntitlementSummaryProps {
  activeTab: string;
}

/**
 * EntitlementSummary
 */
function EntitlementSummary({ activeTab }: EntitlementSummaryProps) {
  const l = useInvertedLocalize();

  return (
    <TabContent
      className='Sod-EntitlementDetails-tabContent'
      value={activeTab}
      tabValue={ENTITLEMENT_DEATILS_TABS.TAB_SUMMARY}>
      <Box className='Sod-EntitlementSummary-tabContentWrapper'>
        <Box tag='div' className='Sod-EntitlementSummary-content'>
          <SodFieldSet
            label={l('Granted Through')}
            value={l('Access Request')}
          />
          <Box className='Sod-EntitlementSummary-columns'>
            <SodFieldSet label={l('Start')} value='01/23/2024' />
            <SodFieldSet label={l('End')} value={l('Not Provided')} />
          </Box>

          <Box tag='span' className='Sod-EntitlementSummary-border' />

          <Box className='Sod-EntitlementSummary-columns'>
            <SodFieldSet
              label={l('Application')}
              value={
                <Box tag='span' className='Sod-EntitlementSummary-application'>
                  <ApplicationIcon logo='SAP' size='xxSmall' />
                  <Typography kind='body2'>{l('SAP')}</Typography>
                </Box>
              }
            />
            <SodFieldSet label={l('Entitlement Type')} value={l('SAP Roles')} />
          </Box>

          <SodFieldSet label={l('Descriptions')} value={l('All Permissions')} />
          <SodFieldSet label={l('Glossary')} value={l('Not Provided')} />
          <SodFieldSet
            label={l('Custom Property 1')}
            value={l('Custom Property 1 Value')}
          />

          <Box className='Sod-EntitlementSummary-columns'>
            <SodFieldSet
              label={l('Sox Critical')}
              value={
                <Tooltip
                  trigger={
                    <Chip
                      size='small'
                      kind='outlined'
                      label={l('Very High')}
                      color='critical'
                      isInteractionDisabled
                    />
                  }
                  text={l('WIP: Content TBD')}
                  placement='bottom'
                />
              }
            />
            <SodFieldSet
              label={l('Sys Critical')}
              value={
                <Tooltip
                  trigger={
                    <Chip
                      size='small'
                      kind='outlined'
                      label={l('Very High')}
                      color='critical'
                      isInteractionDisabled
                    />
                  }
                  text={l('WIP: Content TBD')}
                  placement='bottom'
                />
              }
            />
            <SodFieldSet
              label={l('Risk')}
              value={
                <Tooltip
                  trigger={
                    <Chip
                      size='small'
                      kind='outlined'
                      label={l('Very High')}
                      color='critical'
                      isInteractionDisabled
                    />
                  }
                  text={l('WIP: Content TBD')}
                  placement='bottom'
                />
              }
            />
            <SodFieldSet
              label={l('Privilaged')}
              value={
                <Tooltip
                  trigger={
                    <Chip
                      size='small'
                      kind='outlined'
                      label={l('Very High')}
                      color='critical'
                      isInteractionDisabled
                    />
                  }
                  text={l('WIP: Content TBD')}
                  placement='bottom'
                />
              }
            />
          </Box>

          <SodFieldSet
            label={l('Financial')}
            value={
              <Tooltip
                trigger={
                  <Chip
                    size='small'
                    kind='outlined'
                    label={l('None')}
                    isInteractionDisabled
                  />
                }
                text={l('WIP: Content TBD')}
                placement='bottom'
              />
            }
          />
        </Box>
      </Box>
    </TabContent>
  );
}

export default EntitlementSummary;
